module.exports = __webpack_public_path__ + "5d0dd14cffb0c04e3d2960af92dfbec1.jpg";